import React, { FC } from 'react';
import { useFormState } from 'react-final-form';
import { Typography } from '@material-ui/core';
import { FieldCheckboxGroup } from '../../components';
import { Conditions } from '../../shopConfig/filters/condition';
import Heading from './Heading';
import Subheading from './Subheading';
import { ListingFlowFormField } from './ListingFlowTypes';
import { useListingFlowConfig } from '../../hooks/useListingFlowConfig';
import css from './EditListingPage.module.css';
import { useTradeInConfig } from '../../hooks/useTradeInConfig';
import { ListingItemType } from '../../types/sharetribe/listing';

const QuirksBulletpoints: FC = () => {
  const { quirks } = useListingFlowConfig();

  return (
    <ul className={css.quirksBulletpoints}>
      {quirks.map((quirk: string) => (
        <li key={quirk}>
          <Typography variant="body1" display="inline">
            {quirk}
          </Typography>
        </li>
      ))}
    </ul>
  );
};

const QuirksCheckboxGroup: FC = () => {
  const { quirks } = useListingFlowConfig();

  const quirkOptions = quirks.map((quirk: string) => ({ key: quirk, label: quirk, value: quirk }));

  return (
    <FieldCheckboxGroup
      id={ListingFlowFormField.Quirks}
      name={ListingFlowFormField.Quirks}
      key={ListingFlowFormField.Quirks}
      options={quirkOptions}
      twoColumns
    />
  );
};

const Quirks: FC = () => {
  const { quirks, quirksConditionsLabel, showQuirksForAllConditions } = useListingFlowConfig();
  const { values } = useFormState();
  const tradeInConfig = useTradeInConfig();
  const { condition } = values;

  const shouldShowQuirks =
    quirks &&
    (showQuirksForAllConditions ||
      condition === Conditions.Good ||
      condition === Conditions.Excellent);

  const shouldDisableSelectableQuirks =
    values.itemType === ListingItemType.TradeIn && !tradeInConfig?.enableSelectableQuirks;

  if (!shouldShowQuirks) return null;

  return (
    <>
      <Heading>Quirks</Heading>
      <Subheading>{quirksConditionsLabel}</Subheading>
      {shouldDisableSelectableQuirks ? <QuirksBulletpoints /> : <QuirksCheckboxGroup />}
    </>
  );
};

export default Quirks;
